import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ContactJourneyResponse } from './contact-journey.model';

/**
 * TVG-174: internal Contact journey view. Fetches every finalised quote and
 * event tied to a contact, grouped and staged for the journey bands. Gated
 * server-side on the `crm-sales-flow` toggle (404 when off).
 */
@Injectable({
  providedIn: 'root',
})
export class ContactJourneyService {
  private apiUrl = `${environment.apiUrl}/api/contacts`;

  constructor(private http: HttpClient) {}

  getJourney(contactId: number): Observable<ContactJourneyResponse> {
    return this.http.get<ContactJourneyResponse>(`${this.apiUrl}/${contactId}/journey`);
  }
}
